import { combineReducers } from "@reduxjs/toolkit";
import auth from "./auth";
import in8itauth from "./in8itauth";
import formState from "./applicationreducers";
import bookmarkFilter from "./bookmarkreducer";
import alarmNotificationActions from "./alarmNotificationReducer";
export default combineReducers({
  auth,
  in8itauth,
  formState,
  bookmarkFilter,
  alarmNotificationActions
});
